import React, { PropsWithChildren, ReactElement } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import './FeatureDetailCard.css';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import { wrapTrademarkSuperscript } from '../../utils/cob-utils';
import { Button, Row, Col, Title, Image  } from '../../importCL';

interface IFeatureDetailCardProps extends MappedComponentProperties {
    titleVariant?: 'above' | 'below';
    title?: string;
    img?: string;
    alt?: string;
    description?: string;
    ctaLink?: string;
    ctaLabel?: string;
    imageUrl?: string;
    newTab?: boolean;
    marginBottom?: boolean;
}

export const FeatureDetailCardEditConfig = {
    emptyLabel: 'FeatureDetailCard',
    isEmpty: (props: PropsWithChildren<IFeatureDetailCardProps>) => {
        return !props || !props.title;
    },
};

const FeatureDetailCard = (props: PropsWithChildren<IFeatureDetailCardProps>): JSX.Element => {
    const href = (props.ctaLink ?? '');
    const target = (props.newTab ? '_blank' : '_self');

    return (
        <div id='feature-detail-card' className='FeatureDetailCard'>
            <Row className='FeatureDetailCard__row !my-8 max-w-[37.5rem] px-5 md:max-w-none md:px-3'>
                <Col className='flex flex-col items-start' xs={12}>
                    {props.titleVariant === 'above' && 
                        <Title className='leading-[1.875rem] pb-2.5' tag='h3'>{transformHTMLParserLinks(wrapTrademarkSuperscript(props.title))}</Title>}
                    <Image loading='lazy' className='max-w-full h-auto pb-4' src={props.img} alt={props.alt} />
                    {props.titleVariant === 'below' &&
                        <Title className='leading-5 text-base' tag='h3'>{transformHTMLParserLinks(wrapTrademarkSuperscript(props.title))}</Title>}
                    <span>
                        {props.description && transformHTMLParserLinks(wrapTrademarkSuperscript(props.description))}
                    </span>
                    {props.ctaLabel && <Button className='!border-none !pl-0' target={target} href={href} variant='link'
                        icon='chevron' size='small'>
                        {transformHTMLParserLinks(wrapTrademarkSuperscript(props.ctaLabel)) as unknown as ReactElement}
                    </Button>}
                </Col>
            </Row>
        </div>
    );
};

export default FeatureDetailCard;